const initialState: any = null; // Initial state is null since we expect a single report object or null

/**
 * selectedInspectionReportReducer: Reducer to handle actions related to the selected inspection report data.
 *
 * @param {any} state - The current state of the selected inspection report.
 * @param {any} action - The action dispatched to the reducer.
 * @returns {any} The new state after applying the action.
 */
const selectedInspectionReportReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case "SET_SELECTED_INSPECTION_REPORT":
      return action.payload;
    default:
      return state;
  }
};

export default selectedInspectionReportReducer;